// components/DatePickerInput.jsx
import { useEffect } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

const DatePickerInput = ({ headerText, onDateChange, initialDate }) => {
  
  useEffect(() => {
    const picker = flatpickr("#datePicker", {
      defaultDate: initialDate || new Date(),
      dateFormat: "d M Y",
      maxDate: "today",
      onChange: (selectedDates, dateStr) => {
        onDateChange(dateStr);
      },
    });

    return () => {
      picker.destroy(); // clean up flatpickr on unmount
    };
  }, [onDateChange, initialDate]);

  return (
    <section className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
      <h2 className="text-2xl font-bold page_head_text">{headerText}</h2>
      <div className="w-full sm:w-auto">
        <input
          type="text"
          id="datePicker"
          placeholder="Pick a date"
          className="w-full sm:w-auto border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </section>
  );
};

export default DatePickerInput;
